import { store } from './redux/store'
import { Provider } from 'react-redux'
import { ReactElement, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ProrithmWebSocketProvider } from './features/Prorithm/ProrithmWebSocketContext'
import Sidebar from './features/Sidebar/Sidebar'
import Navigator from './components/navigation/Navigator'
import './App.css'

const App = (): ReactElement => {
  const navigate = useNavigate()
  const hasMounted = useRef(false)
  const location = useLocation()
  const hiddenSidebarRoutes = ['/videoCall']

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true

      if (location.pathname !== '/videoCall') {
        navigate('/')
      }
    }
  }, [location.pathname, navigate])

  return (
    <div className='command-center' id='command-center-app'>
      <Provider store={store}>
        <ProrithmWebSocketProvider>
          {!hiddenSidebarRoutes?.includes(location?.pathname) && <Sidebar />}
          <Navigator />
        </ProrithmWebSocketProvider>
      </Provider>
    </div>
  )
}

export default App
